<div class="qq-beat-your-broker" [appScrollIntoView]="true">
  <ion-spinner *ngIf="loading"></ion-spinner>  
  
  <div class="invalid-feedback d-block" *ngIf="error" [innerHTML]="error"></div>

  <div class="qq-beat-your-broker__block" *ngIf="!loading && !error" [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'display-quote-result'">      
      <div class="savings" *ngIf="result.canBetter && result.savings > 0">
        <span class="amount">{{result.savings | pounds}}{{result.savings | appcents}}</span>
        <span class="sub">Savings per month</span>
      </div> 
      <div class="graph-container">
        <div class="graph">
          <app-apg-pie-chart [chartDataMode]="'Percentage'" [lowValue]="result.assuraPremium" [label]="'Monthly Saving'" 
          [highValue]="result.currentPremium" [colorArray]="colorArray"></app-apg-pie-chart>
        </div>
        <div class="separator">&nbsp;</div> 
        <div class="graph">
          <app-apg-bar-graph [startColor]="'#E0E3E8'" [endColor]="'#132C40'" [lowValue]="0"  [label]="'Annual Saving'" 
          [highValue]="result.savings*12" [steps]="12"></app-apg-bar-graph>
        </div>
      </div>
      <div class="quote-info">        
        <app-site-content [key]="result.contentKey1" class="info" *ngIf="result.contentKey1"></app-site-content>  
        <app-site-content [key]="result.contentKey2" class="info" *ngIf="result.contentKey2"></app-site-content> 
      </div>
      <div class="comparison-container">  
        <app-comparison-table [quickQuote]="quickQuote" [result]="result"></app-comparison-table>
      </div>
      <div class="summary__buttons">
        <ion-button (click)="newQuote()">
          <ion-icon name="chevron-back-outline"></ion-icon>
            Change Quote
        </ion-button>
        <ion-button (click)="next()" *ngIf="result.showContactRequest">
            Continue
            <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </ng-container>

    <ng-container  *ngSwitchCase="'display-result'">        
      <div class="savings" *ngIf="result.canBetter && result.savings > 0">
        <span class="amount">{{result.savings | pounds}}{{result.savings | appcents}}</span>
        <span class="sub">Savings per month</span>
      </div> 
      <div class="quote-info">        
        <app-site-content [key]="result.contentKey1" class="display-result_info" *ngIf="result.contentKey1"></app-site-content>  
        <app-site-content [key]="result.contentKey2" class="display-result_info" *ngIf="result.contentKey2"></app-site-content> 
      </div>  
      <app-contact-request *ngIf="result.showContactRequest" (back)="newQuote()"
      name="BeatYourBroker.ContactRequest" (continue)="saveContactRequest($event)">
      </app-contact-request>  
    </ng-container>

    <ng-container  *ngSwitchCase="'contact-request'">  
      <app-contact-request *ngIf="result.showContactRequest" (back)="newQuote()"
      name="BeatYourBroker.ContactRequest" (continue)="saveContactRequest($event)">
      </app-contact-request> 
    </ng-container>  
  </div>
  
  <div class="summary__buttons"  *ngIf="error" >
    <ion-button (click)="newQuote()">
      <ion-icon name="chevron-back-outline"></ion-icon>
        Change Quote
    </ion-button>
  </div>
</div> 